import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import { fetchBoundTasks } from "actions";
import { useDispatch } from "react-redux";

const TaskFilter = ({ taskExtraFiltersState, setTaskExtraFiltersState, object_viewed_id, programId }) => {
  const dispatch = useDispatch();

  // No dropdown, so no show state needed

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTaskExtraFiltersState((prevState) => ({
      ...prevState,
      values: {
        ...(prevState.values || {}),
        [name]: value,
      },
    }));
  };



  const handleClear = () => {
    setTaskExtraFiltersState({
      values: {
        category: "",
        task: "",
        repAccess: "",
      },
    });
  };

  const handleSearch = () => {
    dispatch(fetchBoundTasks(programId, { object_viewed_id, ...taskExtraFiltersState.values }));
  };

  return (
    <div className="filters-flex">
      <Form>
        <Row className="align-items-end g-3">
          <Col md={4} sm={12}>
            <Form.Group>
              <Form.Label className="label-input">Category</Form.Label>
              <Form.Control
                type="text"
                placeholder="Type Category"
                name="category"
                value={taskExtraFiltersState.values?.category || ""}
                onChange={handleChange}
                className="input-field"
              />
            </Form.Group>
          </Col>
          <Col md={4} sm={12}>
            <Form.Group>
              <Form.Label className="label-input">Task</Form.Label>
              <Form.Control
                type="text"
                placeholder="Type Task"
                name="task"
                value={taskExtraFiltersState.values?.task || ""}
                onChange={handleChange}
                className="input-field"
              />
            </Form.Group>
          </Col>
          <Col md={2} sm={12}>
            <Form.Group>
              <Form.Label className="label-input">Rep Access</Form.Label>
              <Form.Select
                className="input-field"
                name="repAccess"
                value={taskExtraFiltersState.values?.repAccess || ""}
                onChange={handleChange}
              >
                <option value="">Select Rep Access</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={2} sm={12} className="d-flex gap-2 mt-3 mt-md-0">
            <button
              type="button"
              onClick={handleSearch}
              className="add-new-btn w-100"
            >
              <img src="/assets/images/search-white.svg" alt="" className="me-2" /> Search
            </button>
            <button
              type="button"
              onClick={handleClear}
              className="btn btn-link text-danger w-100"
            >
              Clear
            </button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default TaskFilter;
